import { Tabs, Box } from '@nimbus-ds/components';
import { useTranslationDashboard } from 'domains/Dashboard/hooks';
import { useStatisticsDaily } from 'domains/Statistics/hooks';
import { ShowHideAmountsIcon } from './ShowHideAmountsIcon';
import StatsDailyTabContent from './StatsDailyTabContent';
import { Tablike } from './Tablike';

interface CardStatisticsDailyProps {
  showAmounts?: boolean;
  showInline?: boolean;
  onHideAmounts?: () => void;
}

const noop = () => undefined;

function CardStatisticsDaily({
  showAmounts = true,
  showInline = false,
  onHideAmounts = noop,
}: Readonly<CardStatisticsDailyProps>) {
  const t = useTranslationDashboard();
  const { statisticsDaily, loading, showTabs } = useStatisticsDaily();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="4"
      width={showInline ? '100%' : undefined}
      marginBottom="4"
    >
      {showTabs && (
        <ShowHideAmountsIcon
          fixed
          eyeOff={showAmounts}
          onClick={onHideAmounts}
        />
      )}
      {!showTabs ? (
        <Tablike
          label={t('tabs.thisday')}
          eyeOff={showAmounts}
          onHideAmounts={onHideAmounts}
        >
          {loading ? (
            <StatsDailyTabContent.Skeleton />
          ) : (
            <StatsDailyTabContent
              values={statisticsDaily?.today}
              hideAmounts={!showAmounts}
              showInline={showInline}
            />
          )}
        </Tablike>
      ) : (
        <Tabs preSelectedTab={0}>
          <Tabs.Item label={t('tabs.thisday')}>
            {loading && <StatsDailyTabContent.Skeleton />}
            {!loading && (
              <StatsDailyTabContent
                values={statisticsDaily?.today}
                hideAmounts={!showAmounts}
                showInline={showInline}
              />
            )}
          </Tabs.Item>
          <Tabs.Item label={t('tabs.lastday')}>
            {loading && <StatsDailyTabContent.Skeleton />}
            {!loading && (
              <StatsDailyTabContent
                values={statisticsDaily?.yesterday}
                hideAmounts={!showAmounts}
                showInline={showInline}
              />
            )}
          </Tabs.Item>
          <Tabs.Item label={t('tabs.currentWeek')}>
            {loading && <StatsDailyTabContent.Skeleton />}
            {!loading && (
              <StatsDailyTabContent
                values={statisticsDaily?.currentWeek}
                hideAmounts={!showAmounts}
                showInline={showInline}
              />
            )}
          </Tabs.Item>
        </Tabs>
      )}
    </Box>
  );
}

export default CardStatisticsDaily;
